import { render, staticRenderFns } from "./ExpiryDateDialog.vue?vue&type=template&id=00853b49"
import script from "./ExpiryDateDialog.vue?vue&type=script&lang=js"
export * from "./ExpiryDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports